import { getTripPhaseName, getTripPhaseOrder } from '../constants/trip-phases';
import { getTripStatus, getStatusClass, getStatusLabel } from '../constants/trip-status';
import { IWatrRequestTravels } from '@nkr/models/index';
import { WageAndTravelReimbursementRequestStatus } from '@nkr/enums/watr-reimbursement-request-status';

export { getTripPhaseName, getTripPhaseOrder, getTripStatus, getStatusClass, getStatusLabel };

export const filterAddress = (address: string): string => {
    return address.split(/[,#]/)[0];
};

export const findPendingTravelRequest = (travelRequests: IWatrRequestTravels[]): IWatrRequestTravels | null => {
    if (!travelRequests || travelRequests.length === 0) {
        return null;
    }

    const pendingRequest = travelRequests.find(tr => tr.status !== WageAndTravelReimbursementRequestStatus.Reimbursed);
    return pendingRequest || null;
};

const closedTravelClaimStatuses = [
    WageAndTravelReimbursementRequestStatus.AutoApproved,
    WageAndTravelReimbursementRequestStatus.CenterApproved,
    WageAndTravelReimbursementRequestStatus.AdminApproved,
    WageAndTravelReimbursementRequestStatus.Reimbursed,
];

export const getPriorClosedTravelClaims = (travelRequests: IWatrRequestTravels[] | null | undefined): IWatrRequestTravels[] => {
    if (!travelRequests || travelRequests.length === 0) {
        return [];
    }
    return travelRequests.filter(tr => closedTravelClaimStatuses.indexOf(tr.status) >= 0);
};

export const hasPriorClosedTravelClaims = (travelRequests: IWatrRequestTravels[] | null | undefined): boolean =>
    getPriorClosedTravelClaims(travelRequests).length > 0;

